<form [formGroup]="orgForm">
    <div class="grid-x">
        <div class="cell small-12">
            <h4>Organization Name</h4>
        </div>
    </div>
    <div class="grid-x grid-margin-x">
        <div class="cell small-8">
            <label for="title">Name</label>
            <input type="text" id="title" formControlName="name" [(ngModel)]="organization.name" [attr.disabled]="!isInternalUser ? 'disabled' : null" />
            <div class="error-container" *ngIf="orgForm.controls['name'].invalid">
                <small class="error" *ngIf="orgForm.get('name').hasError('required')">Name is required</small>
            </div>
        </div>
        <div *ngIf="showDba" class="cell small-4">
            <label for="isDbaName">DBA Name?</label>
            <div>{{ getDbaStatusDescription() }}</div>
        </div>
    </div>
    <div *ngIf="organization.isDbaName" class="grid-x grid-margin-x">
        <div class="cell small-6">
            <label for="parentTitle">DBA Name:</label>
            <input type="text" id="parentTitle" formControlName="parentOrganizationName" [(ngModel)]="parentOrganization.name" [attr.disabled]="!isInternalUser ? 'disabled' : null" />
            <div class="error-container" *ngIf="orgForm.controls['parentOrganizationName'].invalid">
                <small class="error" *ngIf="orgForm.get('parentOrganizationName').hasError('required')">Name is required</small>
            </div>
        </div>
        <div class="cell small-6">
            <label for="dbaReuseParentInfo">Use primary contact information for DBA contact information?</label>
            <select id="dbaReuseParentInfo" (change)="reuseMainOrgForDbaChange($event)" [attr.disabled]="readOnly ? 'disabled' : null">
                <option [value]="false" selected>No</option>
                <option [value]="true">Yes</option>
            </select>
        </div>
    </div>

    <div *ngIf="displayContacts()">
        <div class="grid-x">
            <div class="cell small-12 medium-4">
                <div>
                    <span class="bold">Organization Entity: </span>{{ getTypeDescription(organization.typeCode) }}
                </div>
                <div>
                    <span class="bold">Owner Number: </span>{{ organization.id }}
                </div>
                <div *ngIf="organization.historicalOwnerNumber?.length > 0">
                    <span class="bold">Legacy Owner Number: </span>{{ organization.historicalOwnerNumber }}
                </div>
            </div>
            <div class="cell small-12 medium-4">
                <div>
                    <span class="bold" [ngClass]="{ 'red': !complianceStatus }">Compliance Status: </span>
                    <label [ngClass]="{ 'red': !complianceStatus }"> {{ complianceStatusText }}</label>
                </div>
            </div>
        </div>

        <div class="grid-x margin-top">
            <div class="cell small-12 medium-4">
                <label class="bold">Primary Contact:</label>
                <div *ngIf="primaryContactExists">
                    <div>{{ (primaryContact ).displayName }}</div>
                    <address-block [address]="(primaryContact).address"></address-block>

                    <div class="margin-top">Phone: {{ (primaryContact).primaryPhone }}</div>
                    <div>Fax: {{ (primaryContact ).fax }}</div>
                    <div>Email: {{ (primaryContact ).emailAddress }}</div>
                </div>
                <div *ngIf="!primaryContactExists">No Primary Contact Provided</div>
            </div>
            <div class="cell small-12 medium-4">
                <label class="bold">Emergency Point Of Contact:</label>
                <div *ngIf="emergencyContactExists">
                    <div>{{ (emergencyContact).displayName }}</div>
                    <address-block [address]="(emergencyContact).address"></address-block>

                    <div class="margin-top">Phone: {{ (emergencyContact).primaryPhone }}</div>
                    <div>Fax: {{ (emergencyContact).fax }}</div>
                    <div>Email: {{ (emergencyContact).emailAddress }}</div>
                </div>
                <div *ngIf="!emergencyContactExists">No Emergency Contact Provided</div>
            </div>
        </div>
    </div>

    <div class="tabs-container" >
        <tabs >
            <tab title="Entity Contact Information">
                <div class="grid-x margin-top">
                    <div class="cell small-12">
                        <h4>Organization Address</h4>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-8">
                        <label for="addressStreet" class="required">Address</label>
                        <input type="text" id="addressStreet" formControlName="addressStreet" [(ngModel)]="organization.address.street" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['addressStreet'].invalid">
                            <small class="error" *ngIf="orgForm.get('addressStreet').hasError('required')">Address is required</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="addressSuite">Suite</label>
                        <input type="text" id="addressSuite" formControlName="addressSuite" [(ngModel)]="organization.address.suite" [attr.disabled]="readOnly ? 'disabled' : null"/>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        <label for="addressPoBox">P.O. Box</label>
                        <input type="text" id="addressPoBox" formControlName="addressPoBox" [(ngModel)]="organization.address.poBox" [attr.disabled]="readOnly ? 'disabled' : null"/>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-6">
                        <label for="addressCity" class="required">City</label>
                        <input type="text" id="addressCity" formControlName="addressCity" [(ngModel)]="organization.address.city" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['addressCity'].invalid">
                            <small class="error" *ngIf="orgForm.get('addressCity').hasError('required')">City is required</small>
                        </div>
                    </div>
                    <div class="cell small-2">
                        <ng-container *ngIf="states; else loading">
                            <label for="addressStateCode">State</label>
                            <select id="addressStateCode" formControlName="addressStateCode" [(ngModel)]="organization.address.stateCode" [attr.disabled]="readOnly ? 'disabled' : null">
                                <option *ngFor="let state of states.values" [value]="state.Code">{{ state.Definition }}</option>
                            </select>
                        </ng-container>
                        <ng-template #loading>
                            Loading...
                        </ng-template>
                    </div>
                    <div class="cell small-4">
                        <label for="addressZipCode" class="required">Zip</label>
                        <input type="text" id="addressZipCode" formControlName="addressZipCode" [(ngModel)]="organization.address.zipCode" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['addressZipCode'].invalid">
                            <small class="error" *ngIf="orgForm.get('addressZipCode').hasError('required')">
                                Zip Code is
                                required
                            </small>
                            <small class="error" *ngIf="orgForm.get('addressZipCode').hasError('pattern')">Zip Code is invalid</small>
                        </div>
                    </div>
                </div>

                <div class="grid-x margin-top">
                    <div class="cell small-12">
                        <h4>Organization Contact Information</h4>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-4">
                        <label for="email">Email</label>
                        <input type="text" id="email" formControlName="email" [(ngModel)]="organization.email" [attr.disabled]="readOnly ? 'disabled' : null">
                        <div class="error-container" *ngIf="orgForm.controls['email'].invalid">
                            <small class="error" *ngIf="orgForm.get('email').hasError('pattern')">Email is invalid</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="phone" class="required">Phone</label>
                        <phonenumber-input id="phone" formControlName="phone" [(ngModel)]="organization.phone" [isDisabled]="readOnly"></phonenumber-input>
                        <div class="error-container" *ngIf="orgForm.controls['phone'].invalid">
                            <small class="error" *ngIf="orgForm.get('phone').hasError('required')">Phone is required</small>
                            <small class="error" *ngIf="orgForm.get('phone').hasError('pattern')">Phone is invalid</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="fax">Fax</label>
                        <phonenumber-input id="fax" formControlName="fax" [(ngModel)]="organization.fax" [isDisabled]="readOnly"></phonenumber-input>
                        <div class="error-container" *ngIf="orgForm.controls['fax'].invalid">
                            <small class="error" *ngIf="orgForm.get('fax').hasError('pattern')">Fax is invalid</small>
                        </div>
                    </div>
                </div>
            </tab>

            <tab title="DBA Contact Information" *ngIf=displayDbaContactTab()>
                <div class="grid-x margin-top">
                    <div class="cell small-12">
                        <h4>DBA Address</h4>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-8">
                        <label for="addressStreet">Address</label>
                        <input type="text" id="parentAddressStreet" formControlName="parentAddressStreet" [(ngModel)]="parentOrganization.address.street" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['parentAddressStreet'].invalid && (orgForm.controls['parentAddressStreet'].dirty || orgForm.controls['parentAddressStreet'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentAddressStreet').hasError('required')">Address is required</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="parentAddressSuite">Suite</label>
                        <input type="text" id="parentAddressSuite" formControlName="parentAddressSuite" [(ngModel)]="parentOrganization.address.suite" [attr.disabled]="readOnly ? 'disabled' : null"/>
                    </div>
                </div>
                <div class="grid-x">
                    <div class="cell small-12">
                        <label for="parentAddressPoBox">P.O. Box</label>
                        <input type="text" id="parentAddressPoBox" formControlName="parentAddressPoBox" [(ngModel)]="parentOrganization.address.poBox" [attr.disabled]="readOnly ? 'disabled' : null"/>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-6">
                        <label for="parentAddressCity">City</label>
                        <input type="text" id="parentAddressCity" formControlName="parentAddressCity" [(ngModel)]="parentOrganization.address.city" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['parentAddressCity'].invalid && (orgForm.controls['parentAddressCity'].dirty || orgForm.controls['parentAddressCity'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentAddressCity').hasError('required')">City is required</small>
                        </div>
                    </div>
                    <div class="cell small-2">
                        <ng-container *ngIf="states; else loading">
                            <label for="parentAddressStateCode">State</label>
                            <select id="parentAddressStateCode" formControlName="parentAddressStateCode" [(ngModel)]="parentOrganization.address.stateCode" [attr.disabled]="readOnly ? 'disabled' : null">
                                <option *ngFor="let state of states.values" [value]="state.Code">{{ state.Definition }}</option>
                            </select>
                        </ng-container>
                        <ng-template #loading>
                            Loading...
                        </ng-template>
                    </div>
                    <div class="cell small-4">
                        <label for="parentAddressZipCode">Zip</label>
                        <input type="text" id="parentAddressZipCode" formControlName="parentAddressZipCode" [(ngModel)]="parentOrganization.address.zipCode" [attr.disabled]="readOnly ? 'disabled' : null"/>
                        <div class="error-container" *ngIf="orgForm.controls['parentAddressZipCode'].invalid && (orgForm.controls['parentAddressZipCode'].dirty || orgForm.controls['parentAddressZipCode'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentAddressZipCode').hasError('required')">
                                Zip Code is
                                required
                            </small>
                            <small class="error" *ngIf="orgForm.get('parentAddressZipCode').hasError('pattern')">Zip Code is invalid</small>
                        </div>
                    </div>
                </div>

                <div class="grid-x margin-top">
                    <div class="cell small-12">
                        <h4>DBA Contact Information</h4>
                    </div>
                </div>
                <div class="grid-x grid-margin-x">
                    <div class="cell small-4">
                        <label for="parentEmail">Email</label>
                        <input type="text" id="parentEmail" formControlName="parentEmail" [(ngModel)]="parentOrganization.email" [attr.disabled]="readOnly ? 'disabled' : null">
                        <div class="error-container" *ngIf="orgForm.controls['parentEmail'].invalid && (orgForm.controls['parentEmail'].dirty || orgForm.controls['parentEmail'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentEmail').hasError('pattern')">Email is invalid</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="phone">Phone</label>
                        <phonenumber-input id="parentPhone" formControlName="parentPhone" [(ngModel)]="parentOrganization.phone" [isDisabled]="readOnly"></phonenumber-input>
                        <div class="error-container" *ngIf="orgForm.controls['parentPhone'].invalid && (orgForm.controls['parentPhone'].dirty || orgForm.controls['parentPhone'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentPhone').hasError('required')">Phone is required</small>
                            <small class="error" *ngIf="orgForm.get('parentPhone').hasError('pattern')">Phone is invalid</small>
                        </div>
                    </div>
                    <div class="cell small-4">
                        <label for="fax">Fax</label>
                        <phonenumber-input id="parentFax" formControlName="parentFax" [(ngModel)]="parentOrganization.fax" [isDisabled]="readOnly"></phonenumber-input>
                        <div class="error-container" *ngIf="orgForm.controls['parentFax'].invalid && (orgForm.controls['parentFax'].dirty || orgForm.controls['parentFax'].touched)">
                            <small class="error" *ngIf="orgForm.get('parentFax').hasError('pattern')">Fax is invalid</small>
                        </div>
                    </div>
                </div>
            </tab>
        </tabs>
    </div>
</form>
